// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Athena-module__button___y_YOr {
  height: 38px;
  margin: -8px 0 8px auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientDetails/fragments/Athena/Athena.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,uBAAA;AACF","sourcesContent":[".button {\n  height: 38px;\n  margin: -8px 0 8px auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Athena-module__button___y_YOr`
};
module.exports = ___CSS_LOADER_EXPORT___;
